import React from 'react';
import COLORS from './themes/default';

const ThemeContext = React.createContext({
  colors: COLORS
});

export default ThemeContext;
